exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".modal{display:none;position:fixed;left:0;top:0;width:100%;height:100%;z-index:120}.modal.is-visible{display:block}", "", {"version":3,"sources":["/divvit-app/client/containers/Modal/client/containers/Modal/style.styl","/divvit-app/client/containers/Modal/style.styl"],"names":[],"mappings":"AAAA,OACE,aAAA,eACA,OACA,MACA,WACA,YACA,WACA,CAEA,kBACE,aAAA,CCCH","file":"style.styl","sourcesContent":[".modal\n  display: none\n  position: fixed\n  left: 0\n  top: 0\n  width: 100%\n  height: 100%\n  z-index: modal-z-index\n\n  &.is-visible\n    display: block\n",".modal {\n  display: none;\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 120;\n}\n.modal.is-visible {\n  display: block;\n}\n/*# sourceMappingURL=client/containers/Modal/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/containers/Modal/style.styl
// module id = 542
// module chunks = 0